import './style.css';
import './scripts/indexedDbTools';
import 'reset-css';
import 'antd/dist/antd.less';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { ApolloProvider } from '@apollo/client';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import VConsole from 'vconsole';
import { LanguageProvider } from 'containers/LanguageProvider/LanguageProvider';
import { translationMessages } from 'i18n';
import reportWebVitals from './reportWebVitals';
import { apolloClient } from './services/apolloClient';
import { queryClient } from './services/queryClient';
import { App } from './App';

// eslint-disable-next-line no-new
if (import.meta.env.DEV && import.meta.env.VITE_VCONSOLE === 'true') new VConsole();

// NOTE: our deployment pipeline uses one build for both dev and prod environments
// so PROD is always set to true
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://9b7fbe11fcf1bb5337058e0c03bc7334@o506301.ingest.us.sentry.io/4508716086919168',
    integrations: [Sentry.browserTracingIntegration()],
    // Tracing
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // detect env by the hostname
    environment: window.location.hostname.includes('dev') ? 'development' : 'production',
    release: (import.meta.env.VITE_CIRCLE_BRANCH ?? '').replace(/\//g, '-').slice(0, 32), // '/' is not allowed in tag names in sentry, max 32 chars
  });
}

// Add page reload confirmation
window.onbeforeunload = function handleBeforeUnload(event) {
  event.preventDefault();
  event.returnValue = '';
};

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider messages={translationMessages}>
      <ApolloProvider client={apolloClient}>
        <QueryClientProvider client={queryClient}>
          <Router>
            <App />
          </Router>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ApolloProvider>
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
